import { useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { useQueryClient } from "@tanstack/react-query";

export function useOeeNotificationsForCompany(companyKey) {
    const queryClient = useQueryClient();

    const normalizedCompanyKey = companyKey != null ? Number(companyKey) : null;

    useEffect(() => {
        if (!normalizedCompanyKey) return;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/hubs/oee-notifications")
            .withAutomaticReconnect()
            .build();

        connection.on("notify", (message) => {
            if (message?.eventType !== "uncodedStopsAndMachineStatusUpdated") return;

            queryClient.invalidateQueries({
                queryKey: ["uncodedStopsAndStatus", normalizedCompanyKey]
            });
        });

        const start = async () => {
            await connection.start();
            await connection.invoke("SubscribeToCompany", normalizedCompanyKey);
        };

        start().catch(console.error);

        return () => {
            connection.stop();
        };
    }, [normalizedCompanyKey, queryClient]);
}

export function useOeeNotificationsForMachine(companyKey, machineId) {
    const queryClient = useQueryClient();

    const normalizedCompanyKey = companyKey != null ? Number(companyKey) : null;
    const normalizedMachineId = machineId != null ? Number(machineId) : null;

    useEffect(() => {
        if (!normalizedCompanyKey || normalizedMachineId == null) return;

        
        const connection = new signalR.HubConnectionBuilder()
        .withUrl("/hubs/oee-notifications")
        .withAutomaticReconnect()
        .build();
        
        connection.on("notify", (message) => {
            if (message?.eventType !== "uncodedStopsAndMachineStatusUpdated") return;
            if (String(message.machineId) !== String(normalizedMachineId)) return;

            queryClient.invalidateQueries({
                queryKey: ["machinestops", machineId],
            });

            queryClient.invalidateQueries({
                queryKey: ["uncodedStopsAndStatus", normalizedCompanyKey]
            });
        });

        const start = async () => {
            await connection.start();
            await connection.invoke("SubscribeToMachine", normalizedMachineId);
        };

        start().catch(console.error);

        return () => {
            connection.stop();
        };
    }, [normalizedCompanyKey, normalizedMachineId, queryClient, machineId]);
}